import { all } from 'redux-saga/effects';
import auth from './auth';
import utils from './utils';
import appUserAuth from './appUserAuth';

export default function* rootSaga() {
  yield all([auth(), utils(), appUserAuth()]);
}
